/**
 * Created by agengmaulana on 5/3/17.
 */
import React from 'react'
import {observer} from 'mobx-react'
import {observable} from 'mobx';
import styles from './../../assets/css/comment.css'


@observer
export default class Comment_Dropdown_Box extends React.Component {


    @observable rows = [];
    constructor(props) {
        super(props);
        this.state={
            value: '',
        }
        this.rows = this.props.dataStore.ListFilters
    }
    render(){



    var namelist =  this.rows.map(
        data => <option className={'selected'}
                    key={data} defaultValue={data}
                    onClick={() => this.props.dataStore.ChangeListFilters(data)} >
                { data.replace("_", " ")}
                </option>
    )
    return(
        <div className={styles.cmt_styledselect+' '+styles.cmt_urut} id="boxhide">
            Urut berdasarkan &nbsp;
            <div className={styles.cmt_caret}></div>
            <select onChange={this.updateState} >
                {namelist}
            </select>
        </div>
    )
    }

    updateState=(event)=> {
        this.props.dataStore.setFilters = event.target.value
        this.setState({value: event.target.value});
        this.props.dataStore.ChangeListFilters(event.target.value)
        this.props.dataStore.anchor = ''
        this.props.dataStore.datastoresModeration = []
        this.props.dataStore.configKomentar.onresize()
    }
    componentDidMount(){
        var element = document.getElementById('boxhide');
        this.props.dataStore.configKomentar.showhide == 1 ? element.style.display = 'none' : ''
    }
}


// WEBPACK FOOTER //
// ./static/src/component/comment_dropdown_box/comment_dropdown_box.js